<template>
	<div>

		<v-icon v-if="isLogged" color="primary" @click="toggleTheme()">mdi-brightness-4</v-icon>

	</div>
</template>

<script>
import mixin from '../mixin';
import store from '../store';
export default {
  mixins: [mixin],
  data() {
    return {

    };
  },

  computed: {

  },

  watch: {
    isLogged(newVal, oldVal) {
      if (newVal) {
        const dark_theme = localStorage.getItem('dark_theme');
        if(dark_theme) {
          if (dark_theme == 'true') {
            this.$vuetify.theme.dark = true;
          }
          else {
            this.$vuetify.theme.dark = false;
          }
        }
      } else {
        this.$vuetify.theme.dark = false;
      }
    }
  },

  mounted() {
    
  },

  created() {
  },

  methods: {
    toggleTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem('dark_theme', this.$vuetify.theme.dark.toString());
    },
  },
};
</script>